import { Loader2 } from "lucide-react";

export function DefaultPendingComponent() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] p-8 text-center">
      <Loader2 className="h-10 w-10 animate-spin text-primary mb-4" />
      <p className="text-muted-foreground font-medium animate-pulse">Loading...</p>
    </div>
  );
}
